import React from "react";
import GenericMandatoryInput from "../GenericMandatoryInput";
import { CommonInputProps } from "./models";

const CityInput = (props: CommonInputProps) => {
  return <GenericMandatoryInput
    {...props}
    title={RESX.Address.City}
    maxLength={serverReference.constants.address.maxCityLength}
  />;
};

export default CityInput;